import React from 'react';

export const TargetCodes = () => {
  return (
    <div className="target-code">
      <div className="target-code-container">
        <div className="color-code color-green"></div>
        <div className="color-name">Normal (1)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-light-yellow"></div>
        <div className="color-name">Hypokinetic (2)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-orange"></div>
        <div className="color-name">Akinetic (3)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-dark-blue"></div>
        <div className="color-name">Dykinetic (4)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-gray"></div>
        <div className="color-name">Aneurysmal (5)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-red"></div>
        <div className="color-name">Akinetic w/scar (6)</div>
      </div>
      <div className="target-code-container">
        <div className="color-code color-purple"></div>
        <div className="color-name">Dyskinetic w/scar (7)</div>
      </div>
    </div>
  );
};
